import React, { PureComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { commonUtil, qAccessibilityLabel, QavEvent, logEvent } from '@qnpm/q-design-utils';
import DayList from './DayList';
import ToolTips from './ToolTips';
import FakeDayText from './FakeDayText';
import { computeToolTipPosition } from '../../utils/handle';
const DEFAULT_POSITION = {
    pageX: 0,
    pageY: 0,
    position: 'center'
};
export default class MonthContent extends PureComponent {
    constructor(props) {
        super(props);
        this.onItemPress = (data, position) => {
            const { onSelect, isTouchMoving, accessibilityPreName, mode } = this.props;
            // 正在滚动时，禁止点击
            if (isTouchMoving) {
                logEvent(new QavEvent({
                    page: accessibilityPreName,
                    model: 'month_content',
                    action: 'prevent_select_date_on_scrolling',
                    attributes: {
                        mode,
                        operTime: Date.now()
                    }
                }));
                return;
            }
            onSelect && onSelect(data, position);
            this.showToolTips(position, data.extra, data.value);
        };
        this.state = {
            toolTipVisible: false,
            toolTipText: '',
            toolTipPosition: DEFAULT_POSITION
        };
    }
    componentDidMount() {
        const { selectedDate, canShowToolTip } = this.props;
        if (selectedDate && (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.length) && canShowToolTip) {
            const { extra, ids, value } = selectedDate.slice(-1)[0] || {};
            // 额外配置信息及位置信息都存在
            if (commonUtil.isValidObject(extra) &&
                commonUtil.isValidObject(ids)) {
                const { toolTip = '' } = extra || {};
                const toolTipSize = this.getToolTipSize(toolTip);
                // 如果已经有提示文字大小信息，则直接设置为0延迟
                const duration = toolTipSize ? 0 : 500;
                // 这里等待800毫秒，再去执行，否则无法计算文字宽度
                setTimeout(() => {
                    this.showToolTips(ids, extra, value);
                }, duration);
            }
        }
    }
    render() {
        const { selectedDate, dataSource, rowID, dayScale, mode, canShowToolTip = false, dataConfig, selectedSameDay, computedStyle, accessibilityPreName, startTime, endTime, allowDates, denyDates, denyWeeks, refreshWidth } = this.props;
        const { toolTipVisible, toolTipPosition, toolTipText } = this.state;
        return (<View {...qAccessibilityLabel(`${accessibilityPreName}MonthContent#${rowID}`)} style={[styles.wrapper, computedStyle.monthContent.wrapper]}>
                <View style={styles.monthContent}>
                    {dataSource.map((item, index) => (<DayList key={'row_' + index} data={item} rowID={index} blockID={rowID} selectedDate={selectedDate} onSelect={this.onItemPress} dayScale={dayScale} dataConfig={dataConfig} selectedSameDay={selectedSameDay} mode={mode} computedStyle={computedStyle} accessibilityPreName={accessibilityPreName} startTime={startTime} endTime={endTime} allowDates={allowDates} denyDates={denyDates} denyWeeks={denyWeeks} refreshWidth={refreshWidth}/>))}
                    {this.renderUnderMonth()}
                </View>
                <ToolTips visible={toolTipVisible && canShowToolTip} content={toolTipText} arrowPosition={toolTipPosition.position} computedStyle={computedStyle} style={{
            top: toolTipPosition.pageY,
            left: toolTipPosition.pageX
        }} arrowOffset={toolTipPosition.arrowOffset} refreshWidth={refreshWidth}/>
            </View>);
    }
    /**
     * 渲染日历底部的月份文字
     */
    renderUnderMonth() {
        const { month, showUnderMonth, computedStyle } = this.props;
        if (!showUnderMonth || !month) {
            return null;
        }
        return (<View style={styles.underMonthContainer}>
                <Text style={[
            styles.underText,
            computedStyle.monthContent.underText
        ]}>
                    {month}
                </Text>
            </View>);
    }
    /**
     * 获取文字大小
     * @param key
     */
    getToolTipSize(key) {
        // 从Ghost组件获取文字大小
        const { contentSize } = FakeDayText.prototype;
        return contentSize[key];
    }
    /**
     * 展示toolTips
     * @param extra
     * @param position
     * @param date
     */
    showToolTips(position, extra = {}, date) {
        const { toolTip = '' } = extra || {};
        const { toolTipText } = this.state;
        // 如果没有展示文案，则直接终止操作
        if (!toolTip) {
            // 如果还在展示提示的话，则隐藏
            toolTipText &&
                this.setState({ toolTipVisible: false, toolTipText: '' });
            return;
        }
        const { needScale, accessibilityPreName, mode } = this.props;
        const toolTipSize = this.getToolTipSize(toolTip);
        // 如果没有拿到数据的话，则不展示了
        if (!toolTipSize) {
            logEvent(new QavEvent({
                page: accessibilityPreName,
                model: 'month_content',
                action: 'get_tooltip_size_failed',
                attributes: {
                    mode,
                    date,
                    operTime: Date.now()
                }
            }));
            return;
        }
        // 计算提示框位置
        const toolTipPosition = computeToolTipPosition(toolTipSize, position, needScale);
        this.setState({
            toolTipVisible: true,
            toolTipPosition,
            toolTipText: toolTip
        });
        logEvent(new QavEvent({
            page: accessibilityPreName,
            model: 'month_content',
            action: 'show_select_date_tooltip',
            attributes: {
                message: toolTip,
                mode,
                date,
                operTime: Date.now()
            }
        }));
    }
}
const styles = StyleSheet.create({
    wrapper: {
        flex: 1,
        backgroundColor: '#FFFFFF'
    },
    monthContent: {
        flex: 1,
        alignItems: 'center',
        backgroundColor: '#FFFFFF'
    },
    underMonthContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: -1
    },
    underText: {
        fontWeight: '700',
        color: '#f7f7f7',
        textAlign: 'center',
        textAlignVertical: 'center'
    }
});
